import React from 'react';
import PatientInsuranceTable from 'components/molecules/admin-panel/forms/patient-insurance/table';

import type { ModuleType } from 'infrastructure/enums';

interface IAdminTabbedFormPatientInsuranceProps {
  patientGuid: string;
  module: ModuleType;
  readOnly?: boolean;
}

const AdminTabbedFormPatientInsurance: React.FC<
  IAdminTabbedFormPatientInsuranceProps
> = (props) => {
  const { patientGuid, module, readOnly } = props;

  return (
    <PatientInsuranceTable
      patientGuid={patientGuid}
      module={module}
      readOnly={readOnly}
    />
  );
};

export default AdminTabbedFormPatientInsurance;
